import React from 'react';
import PropTypes from 'prop-types';

// Components
import Link from '../../Link/Link';

const LinkedInButton = ({ postLink, title }) => (
  <Link
    className="social-button-link"
    rel="noopener noreferrer"
    target="_blank"
    href={`http://www.linkedin.com/shareArticle?mini=true&url=${postLink}&title=${title}`}
    title={title}
  >
    <div className="social-button-icon flex-center">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 0C5.37256 0 0 5.37256 0 12C0 18.6274 5.37256 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37256 18.6274 0 12 0ZM8.68652 17.9891H6.19739V9.98816H8.68653V17.9891H8.68652ZM7.44263 8.89502C6.64398 8.89502 6 8.24896 6 7.45288C6 6.65698 6.64398 6.01092 7.44263 6.01092C8.2381 6.01092 8.88391 6.65698 8.88391 7.45288C8.88391 8.24896 8.2381 8.89502 7.44263 8.89502ZM18 17.9891H15.5135V14.0982C15.5135 13.1704 15.4976 11.9768 14.2215 11.9768C12.9276 11.9768 12.7302 12.988 12.7302 14.0318V17.9891H10.2465V9.98816H12.6301V11.082H12.6643C12.9958 10.4529 13.8071 9.78961 15.0169 9.78961C17.5347 9.78961 18 11.4463 18 13.6011V17.9891Z"
          fill="#0A66C2"
        />
      </svg>
    </div>
  </Link>
);

LinkedInButton.propTypes = {
  postLink: '',
};

LinkedInButton.propTypes = {
  title: PropTypes.string.isRequired,
  postLink: PropTypes.string.isRequired,
};

export default LinkedInButton;
